var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.99965C0.5 3.86705 0.552678 3.73987 0.646447 3.6461C0.740215 3.55233 0.867392 3.49966 1 3.49966H7.793L5.146 0.853655C5.09951 0.807167 5.06264 0.751978 5.03748 0.691238C5.01232 0.630499 4.99937 0.565399 4.99937 0.499655C4.99937 0.433911 5.01232 0.368811 5.03748 0.308072C5.06264 0.247332 5.09951 0.192143 5.146 0.145655C5.19249 0.099167 5.24768 0.0622909 5.30842 0.0371318C5.36916 0.0119727 5.43426 -0.000976563 5.5 -0.000976562C5.56574 -0.000976562 5.63084 0.0119727 5.69158 0.0371318C5.75232 0.0622909 5.80751 0.099167 5.854 0.145655L9.354 3.64565C9.40056 3.6921 9.43751 3.74728 9.46271 3.80802C9.48792 3.86877 9.50089 3.93389 9.50089 3.99965C9.50089 4.06542 9.48792 4.13054 9.46271 4.19129C9.43751 4.25203 9.40056 4.30721 9.354 4.35365L5.854 7.85365C5.76011 7.94754 5.63278 8.00029 5.5 8.00029C5.36722 8.00029 5.23989 7.94754 5.146 7.85365C5.05211 7.75977 4.99937 7.63243 4.99937 7.49965C4.99937 7.36688 5.05211 7.23954 5.146 7.14565L7.793 4.49965H1C0.867392 4.49965 0.740215 4.44698 0.646447 4.35321C0.552678 4.25944 0.5 4.13226 0.5 3.99965Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4424c97901eeafd01f94da131e9d64c2.svg";
export { ForwardRef as ReactComponent };